import angular from 'angular'

angular.module('nominas.cotizaciones')
  .service('NominasCotizaciones', NominasCotizaciones);

function NominasCotizaciones($api, $schema, $catalogos) {
  this.agregar = agregar;
  this.lista = lista;
  this.listaProyectos = listaProyectos;

  function agregar(data) {
    return $api.post('kendu/nominas/cotizaciones/agregar', {
      data: schema(data, true),
    });
  }

  function lista(fecha_inicio, fecha_fin, ids_empresas) {
    return $api
      .get('kendu/nominas/cotizaciones', {
        fecha_inicio: fecha_inicio.toYMD(),
        fecha_fin: fecha_fin.toYMD(),
        ids_empresas: ids_empresas,
      })
      .then(function (data) {
        return data.map(function (item) {
          return schema(item);
        });
      });
  }

  function listaProyectos() {
    return $catalogos.get('proyectos');
  }

  function schema(data, reverse) {
    return $schema(data, {
      Cerrada: 'boolean',
      Fecha_Inicial: 'date',
      Fecha_Final: 'date',
      Fecha_Pago: 'date',
      Percepciones: 'number',
      Deducciones: 'number',
      Empleados: 'number',
    }, reverse);
  }
}



// WEBPACK FOOTER //
// ./src/nominas/cotizaciones/services/NominasCotizaciones.js